import React, { Component, useState } from 'react';
import { Link } from 'react-router-dom';

// ========== ELEMENTS ==========
import Loader from '../elements/Loader';
import NavBar from '../parts/NavBar';
import Footer from '../parts/Footer';

// ========== SCSS ==========
import '../scss/list.scss';

export class UserRegistry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      search: ''
    };
  }

  handleChange(e) {
    const value = e.target.value;
    this.setState({
      ...this.state,
      [e.target.name]: value
    });
  }

  async getUserList() {
    let response = await window.doRequest('GET', {
      action: 'getUsers',
      token: sessionStorage.getItem('token')
    });

    if (response.status) {
      this.setState({
        loading: false,
        user_list: response.content
      });
    } else
        window.alert(response.message);
  }

  async deleteUser(userId) {
    let response = await window.doRequest('POST', {
      action: 'deleteUser',
      token: sessionStorage.getItem('token'),
      id: userId
    });

    if (response.status) {
      this.props.history.push('/list/user');
    } else
        window.alert(response.message);
  }

  getUserListElements() {
    let elements = [];
    this.state.user_list.forEach((user, i) => {
      if ((this.state.search == '' || this.state.search == null) || (this.state.search != '' && window.normalizeString(user.username).includes(window.normalizeString(this.state.search)))) {
        elements.push(
          <tr key={ user.id }>
            <td>{ user.username }</td>
            <td>
              <a
                href={ 'mailto:' + user.email }
                target="_blank"
                rel="noopener"
              >
                { user.email }
              </a>
            </td>
            <td>
              <Link
                to={{
                  pathname: '/registry/user',
                  user_info: user
                }}
                className="btn"
              >
                Editar...
              </Link>
              <button
                className="btn red"
                onClick={(e) => {

                  // action verification
                  if (window.confirm('Deletar usuário?')) {
                    this.deleteUser(user.id);
                  }

                }}
              >
                Apagar
              </button>
            </td>
          </tr>
        );
      }
    });

    return elements;
  }

  componentDidMount() {
    window.verifyIfIsLogged();

    this.getUserList();
  }

  render() {
    return (
      <main>
        <NavBar />
        <section id="list">
          <div className="container">
            <h1 className="title">Usuários</h1>
            <div className="header-container">
              <form className="search-form" id="searchForm" role="search">
                <div className="content">
                  <button id="searchsubmit" value="Busca" onClick={(e) => { e.preventDefault() }}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="18pt" version="1.1" viewBox="-1 0 136 136.21852" width="18pt">
                      <g id="surface1">
                        <path d="M 93.148438 80.832031 C 109.5 57.742188 104.03125 25.769531 80.941406 9.421875 C 57.851562 -6.925781 25.878906 -1.460938 9.53125 21.632812 C -6.816406 44.722656 -1.351562 76.691406 21.742188 93.039062 C 38.222656 104.707031 60.011719 105.605469 77.394531 95.339844 L 115.164062 132.882812 C 119.242188 137.175781 126.027344 137.347656 130.320312 133.269531 C 134.613281 129.195312 134.785156 122.410156 130.710938 118.117188 C 130.582031 117.980469 130.457031 117.855469 130.320312 117.726562 Z M 51.308594 84.332031 C 33.0625 84.335938 18.269531 69.554688 18.257812 51.308594 C 18.253906 33.0625 33.035156 18.269531 51.285156 18.261719 C 69.507812 18.253906 84.292969 33.011719 84.328125 51.234375 C 84.359375 69.484375 69.585938 84.300781 51.332031 84.332031 C 51.324219 84.332031 51.320312 84.332031 51.308594 84.332031 Z M 51.308594 84.332031 " style={{stroke: 'none', fillRule: 'nonzero', fillOpacity: 1}} />
                      </g>
                    </svg>
                  </button>
                  <input type="text" name="search" placeholder="Pesquisar nome de usuário" required value={this.state.search} onChange={(e) => {this.handleChange(e)}} />
                </div>
              </form>
            </div>
            {
              this.state.loading
                ? <Loader />
                : <div className="list-container">
                    <table className="user-list" cellSpacing="0" cellPadding="0">
                      <thead>
                        <tr>
                          <th>Usuário</th>
                          <th>E-mail</th>
                          <th>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        { this.getUserListElements() }
                      </tbody>
                    </table>
                    <div className="controllers">
                      <Link to="/registry/user" className="btn">Novo...</Link>
                    </div>
                  </div>
            }
          </div>
        </section>
        <Footer />
      </main>
    );
  }
}

export default UserRegistry
